import { mapGetters, mapMutations, mapActions } from 'vuex';
import mvtPopSignin from '@/common/components/mvtpopsignin/mvt-popsignin.vue';
import valuationWelcome from '@/valuation/components/valuationwelcome/valuation-welcome.vue';
import valuationCard from '@/valuation/components/valuationcard/valuation-card.vue';
import mortgageTools from '@/staticpages/components/common/mortgagetools/mortgagetools.vue';
import mvtArticle from '@/common/components/mvtarticle/mvt-article.vue';
import mvtFaq from '@/common/components/mvtfaq/mvt-faq.vue';
import faqConf from '@/common/store/glb/data.faqs';
import valuationHotlead from '@/valuation/components/valuationhotlead/valuation-hotlead.vue';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import { getRecords } from '@/common/utilities/nojq/_notification.js';
import { resolveClickCta } from '@/common/utilities/nojq/_utilities.js';

export default {
    name: 'pageValuation',
    inject: ['$eventBus'],
    components: {
        mvtPopSignin,
        mvtDialogCenter,
        valuationWelcome,
        valuationCard,
        valuationHotlead,
        mortgageTools,
        mvtArticle,
        faqConf,
        mvtFaq,
        mvtHeader,
        mvtFooter,
    },
    computed: {
        ...mapGetters('glb', ['glb']),
    },
    data() {
        return {
            faqQuery: faqConf.homeworth,
        };
    },
    mounted() {
        let data = getRecords();
        this.updateSubscriptions(data.filter((item) => !item.disabled));
        this.$eventBus.$emit('eventbus-pageLoaded');
    },
    methods: {
        ...mapActions('glb', ['fetchArticleFeeds']),
        ...mapMutations('glb', ['updateSubscriptions']),
        show3rdPartyForm(id, url, evt) {
            this.$eventBus.$emit('eventbus-pop-3rdparty', {
                id: id,
                url: url,
                trigger: this.$options.name,
                cta: resolveClickCta('', evt, 'SEARCH'),
            });
        },
    },
};
